// extracted by mini-css-extract-plugin
module.exports = {"mobileSize":"900","top":"Pillars-module--top--1jql9","list":"Pillars-module--list--3ZSN7"};